/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

const Default = {
  FIRST_LOAD_CARD_WALL_ROWS: 30,
  FIRST_LOAD_CARD_WALL_MINI: 60,
  ROWS_COUNT: 8,
  USER_INITIALS_LEN: 3,
  MINI_CARD_RATIO: 0.375,
  LIMIT_VRS_VALUE: 8,
  HEARTBEAT_INTERVAL: 5,
  HEARTBEAT_TIMEOUT: 30,
  heirarchy: [1, 2, 3, 4, 5],
  tableFields: {
    1: {
      name: 'Stories',
      source: 'workPackageReducer.stories',
      fields: [
        {
          name: 'Rank',
          source: 'rank',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupLeft: true
        },
        {
          name: 'ID',
          source: 'id',
          visible: true,
          minWidth: 25,
          maxWidth: 45,
          groupLeft: true
        },
        {
          name: 'Title',
          source: 'name',
          visible: true,
          groupLeft: true
        },
        // {
        //   name: 'Description',
        //   source: 'description',
        //   visible: false
        // },
        {
          name: 'Parent',
          source: 'parent_id',
          visible: true,
          minWidth: 25,
          maxWidth: 45
        },
        {
          name: 'Owner',
          source: 'owner.name',
          visible: false,
          minWidth: 50,
          maxWidth: 50
        },
        {
          name: 'Blocked',
          source: 'blocked',
          visible: false,
          minWidth: 25,
          maxWidth: 30
        },
        {
          name: 'Target',
          source: 'target_id',
          visible: false,
          minWidth: 35,
          maxWidth: 45
        },
        {
          name: 'Team',
          source: 'team_id',
          visible: false,
          minWidth: 35,
          maxWidth: 45
        },
        {
          name: 'Product',
          source: 'product_id',
          visible: false,
          minWidth: 60,
          maxWidth: 60
        },
        {
          name: 'Sprint',
          source: 'current_cadence.sprint_id',
          visible: true,
          minWidth: 25,
          maxWidth: 40
        },
        {
          name: 'Date added',
          source: 'created_at',
          visible: false,
          minWidth: 70,
          maxWidth: 70
        },
        {
          name: 'Estimate',
          source: 'task_estimate',
          visible: false,
          minWidth: 25,
          maxWidth: 40
        },
        {
          name: 'Remaining',
          source: 'remaining_estimate',
          visible: false,
          minWidth: 25,
          maxWidth: 40
        },
        {
          name: 'Closed Date',
          source: 'accepted_at',
          visible: false,
          minWidth: 25,
          maxWidth: 40,
          isDefect: true
        },
        {
          name: 'Created by',
          source: 'created_by',
          visible: false,
          minWidth: 25,
          maxWidth: 40,
          isDefect: true
        },
        {
          name: 'Type',
          source: 'result_type.kind',
          visible: false,
          minWidth: 50,
          maxWidth: 50
        },
        {
          name: 'Value',
          source: 'result_type.type_attributes.value',
          visible: true,
          minWidth: 35,
          maxWidth: 40,
          groupRight: true
        },
        {
          name: 'Risk',
          source: 'result_type.type_attributes.risk',
          visible: true,
          under: 'RROE',
          minWidth: 25,
          maxWidth: 40,
          groupRight: true
        },
        {
          name: 'Size',
          source: 'result_type.type_attributes.size',
          visible: true,
          minWidth: 35,
          maxWidth: 40,
          groupRight: true
        },
        {
          name: 'State',
          source: 'state',
          visible: true,
          minWidth: 25,
          maxWidth: 40,
          groupRight: true
        }
      ]
    },
    2: {
      name: 'Features',
      source: 'workPackageReducer.features',
      fields: [
        {
          name: 'Rank',
          source: 'rank',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupLeft: true
        },
        {
          name: 'ID',
          source: 'id',
          visible: true,
          minWidth: 25,
          maxWidth: 45,
          groupLeft: true
        },
        { name: 'Title', source: 'name', visible: true, groupLeft: true },
        // {
        //   name: 'Description',
        //   source: 'description',
        //   visible: false
        // },
        {
          name: 'Target',
          source: 'targets',
          visible: false,
          minWidth: 25,
          maxWidth: 45
        },
        {
          name: 'Team',
          source: 'team_id',
          visible: false,
          minWidth: 35,
          maxWidth: 45
        },
        {
          name: 'Product',
          source: 'product_id',
          visible: false,
          minWidth: 60,
          maxWidth: 60
        },
        {
          name: 'Parent',
          source: 'parent_id',
          visible: true,
          minWidth: 25,
          maxWidth: 45
        },
        {
          name: 'Owner',
          source: 'owner.name',
          visible: false,
          minWidth: 50,
          maxWidth: 50
        },
        {
          name: 'Type',
          source: 'result_type.kind',
          visible: false,
          minWidth: 50,
          maxWidth: 50
        },
        {
          name: 'Blocked',
          source: 'blocked',
          visible: false,
          minWidth: 25,
          maxWidth: 30
        },
        {
          name: 'Date added',
          source: 'created_at',
          visible: false,
          minWidth: 70,
          maxWidth: 70
        },
        {
          name: 'Value',
          source: 'result_type.type_attributes.value',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'TC',
          source: 'result_type.type_attributes.tc',
          visible: true,
          minWidth: 25,
          maxWidth: 35,
          groupRight: true
        },
        {
          name: 'RROE',
          source: 'result_type.type_attributes.rroe',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'Size',
          source: 'result_type.type_attributes.size',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'WSJF',
          source: 'wsjf',
          visible: true,
          minWidth: 35,
          maxWidth: 40,
          groupRight: true
        },
        {
          name: 'State',
          source: 'state',
          visible: true,
          minWidth: 35,
          maxWidth: 40,
          groupRight: true
        }
      ]
    },
    3: {
      name: 'Capabilities',
      source: 'workPackageReducer.capabilities',
      fields: [
        {
          name: 'Rank',
          source: 'rank',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupLeft: true
        },
        {
          name: 'ID',
          source: 'id',
          visible: true,
          minWidth: 25,
          maxWidth: 45,
          groupLeft: true
        },
        { name: 'Title', source: 'name', visible: true, groupLeft: true },
        // {
        //   name: 'Description',
        //   source: 'description',
        //   visible: false
        // },
        {
          name: 'Target',
          source: 'targets',
          visible: false,
          minWidth: 25,
          maxWidth: 45
        },
        {
          name: 'Parent',
          source: 'parent_id',
          visible: false,
          minWidth: 25,
          maxWidth: 45
        },
        {
          name: 'Owner',
          source: 'owner.name',
          visible: false,
          minWidth: 50,
          maxWidth: 50
        },
        {
          name: 'Type',
          source: 'result_type.kind',
          visible: false,
          minWidth: 50,
          maxWidth: 50
        },
        {
          name: 'Product',
          source: 'product_id',
          visible: false,
          minWidth: 60,
          maxWidth: 60
        },
        {
          name: 'Team',
          source: 'team_id',
          visible: false,
          minWidth: 35,
          maxWidth: 45
        },
        {
          name: 'Blocked',
          source: 'blocked',
          visible: false,
          minWidth: 25,
          maxWidth: 30
        },
        {
          name: 'Date added',
          source: 'created_at',
          visible: false,
          minWidth: 70,
          maxWidth: 70
        },
        {
          name: 'Value',
          source: 'result_type.type_attributes.value',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'TC',
          source: 'result_type.type_attributes.tc',
          visible: true,
          minWidth: 25,
          maxWidth: 35,
          groupRight: true
        },
        {
          name: 'RROE',
          source: 'result_type.type_attributes.rroe',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'Size',
          source: 'result_type.type_attributes.size',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'WSJF',
          source: 'wsjf',
          visible: true,
          minWidth: 35,
          maxWidth: 40,
          groupRight: true
        },
        {
          name: 'State',
          source: 'state',
          visible: true,
          minWidth: 35,
          maxWidth: 40,
          groupRight: true
        }
      ]
    },
    4: {
      name: 'Epics',
      source: 'workPackageReducer.epics',
      fields: [
        {
          name: 'Rank',
          source: 'rank',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupLeft: true
        },
        {
          name: 'ID',
          source: 'id',
          visible: true,
          minWidth: 25,
          maxWidth: 45,
          groupLeft: true
        },
        { name: 'Title', source: 'name', visible: true, groupLeft: true },
        // {
        //   name: 'Description',
        //   source: 'description',
        //   visible: false
        // },
        {
          name: 'Target',
          source: 'targets',
          visible: false,
          minWidth: 25,
          maxWidth: 45
        },
        {
          name: 'Owner',
          source: 'owner.name',
          visible: false,
          minWidth: 50,
          maxWidth: 50
        },
        {
          name: 'Type',
          source: 'result_type.kind',
          visible: false,
          minWidth: 50,
          maxWidth: 50
        },
        {
          name: 'Product',
          source: 'product_id',
          visible: false,
          minWidth: 60,
          maxWidth: 60
        },
        {
          name: 'Team',
          source: 'team_id',
          visible: false,
          minWidth: 35,
          maxWidth: 45
        },
        {
          name: 'Blocked',
          source: 'blocked',
          visible: false,
          minWidth: 25,
          maxWidth: 30
        },
        {
          name: 'Date added',
          source: 'created_at',
          visible: false,
          minWidth: 70,
          maxWidth: 70
        },
        {
          name: 'Value',
          source: 'result_type.type_attributes.value',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'TC',
          source: 'result_type.type_attributes.tc',
          visible: true,
          minWidth: 25,
          maxWidth: 35,
          groupRight: true
        },
        {
          name: 'RROE',
          source: 'result_type.type_attributes.rroe',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'Size',
          source: 'result_type.type_attributes.size',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'WSJF',
          source: 'wsjf',
          visible: true,
          minWidth: 35,
          maxWidth: 40,
          groupRight: true
        },
        {
          name: 'State',
          source: 'state',
          visible: true,
          minWidth: 35,
          maxWidth: 40,
          groupRight: true
        }
      ]
    },
    5: {
      name: 'Organization',
      source: 'userReducer.user.organizations',
      fields: [
        { name: 'empty', source: '', visible: true },
        { name: 'ID', source: 'id', visible: true },
        { name: 'Name', source: 'name', visible: true }
      ]
    },
    cadence: {
      fields: [
        {
          name: 'Rank',
          source: 'rank',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupLeft: true
        },
        {
          name: 'ID',
          source: 'id',
          visible: true,
          minWidth: 25,
          maxWidth: 45,
          groupLeft: true
        },
        { name: 'Title', source: 'name', visible: true, groupLeft: true },
        {
          name: 'Sprint',
          source: 'current_cadence.sprint_id',
          visible: true,
          minWidth: 25,
          maxWidth: 40
        },
        {
          name: 'Value',
          source: 'result_type.type_attributes.value',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'Risk',
          source: 'result_type.type_attributes.rroe',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'Size',
          source: 'result_type.type_attributes.size',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'State',
          source: 'state',
          visible: true,
          minWidth: 35,
          maxWidth: 40,
          groupRight: true
        }
      ]
    },
    cadenceScope: {
      fields: [
        {
          name: 'Rank',
          source: 'rank',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupLeft: true
        },
        {
          name: 'ID',
          source: 'id',
          visible: true,
          minWidth: 25,
          maxWidth: 45,
          groupLeft: true
        },
        { name: 'Title', source: 'name', visible: true, groupLeft: true },
        {
          name: 'Target',
          source: 'targets',
          visible: false,
          minWidth: 25,
          maxWidth: 45
        },
        {
          name: 'Owner',
          source: 'owner.name',
          visible: true,
          minWidth: 50,
          maxWidth: 50
        },
        {
          name: 'Value',
          source: 'result_type.type_attributes.value',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'Risk',
          source: 'result_type.type_attributes.rroe',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'Size',
          source: 'result_type.type_attributes.size',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'State',
          source: 'state',
          visible: true,
          minWidth: 35,
          maxWidth: 40,
          groupRight: true
        }
      ]
    },
    target: {
      fields: [
        {
          name: 'Rank',
          source: 'rank',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupLeft: true
        },
        {
          name: 'ID',
          source: 'id',
          visible: true,
          minWidth: 25,
          maxWidth: 45,
          groupLeft: true
        },
        { name: 'Title', source: 'name', visible: true, groupLeft: true },
        {
          name: 'Team',
          source: 'team_id',
          visible: true,
          minWidth: 35,
          maxWidth: 45
        },
        {
          name: 'Value',
          source: 'result_type.type_attributes.value',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'TC',
          source: 'result_type.type_attributes.tc',
          visible: true,
          minWidth: 25,
          maxWidth: 35,
          groupRight: true
        },
        {
          name: 'RROE',
          source: 'result_type.type_attributes.rroe',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'Size',
          source: 'result_type.type_attributes.size',
          visible: true,
          minWidth: 35,
          maxWidth: 45,
          groupRight: true
        },
        {
          name: 'WSJF',
          source: 'wsjf',
          visible: true,
          minWidth: 35,
          maxWidth: 40,
          groupRight: true
        },
        {
          name: 'State',
          source: 'state',
          visible: true,
          minWidth: 35,
          maxWidth: 40,
          groupRight: true
        }
      ]
    }
  },
  resultTypes: {
    userStory: 'UserStory',
    defect: 'Defect',
    technicalItem: 'TechnicalItem',
    spike: 'Spike',
    feature: 'Feature',
    capability: 'Capability',
    epic: 'Epic'
  },
  levelFromType: {
    'User Story': 1,
    Defect: 1,
    'Technical Item': 1,
    Spike: 1,
    Feature: 2,
    Capability: 3,
    Epic: 4
  }
};

export default Default;
